<form [formGroup]="form" *ngIf="form">
    <h5>Time/Location Filters</h5>
    <div class="content k-d-flex k-flex-col gap-24 k-mt-5">
        <ng-container>
            <div class="k-d-flex district-borough">
                <kendo-floatinglabel text="School Year Term"
                    class="functional-grade-level__form-label district-borough-width">
                    <kendo-dropdownlist [data]="schoolYears" size="large" rounded="large" textField="value"
                        valueField="value" formControlName="schoolYearTerm">
                    </kendo-dropdownlist>
                </kendo-floatinglabel>
                <kendo-floatinglabel text="Preschool Type" *ngIf="studentDetails?.isPreSchool"
                    class="functional-grade-level__form-label district-borough-width">
                    <kendo-dropdownlist [data]="referenceData?.preSchoolType" size="large" rounded="large"
                        textField="description" valueField="description" formControlName="preSchoolType">
                    </kendo-dropdownlist>
                </kendo-floatinglabel>
                <kendo-floatinglabel text="IEP Placement Recommendation" *ngIf="!studentDetails?.isPreSchool"
                    class="functional-grade-level__form-label district-borough-width">
                    <kendo-dropdownlist [data]="referenceData?.placementRecType" size="large" rounded="large"
                        textField="description" valueField="description" formControlName="placementRecType">
                    </kendo-dropdownlist>
                </kendo-floatinglabel>
            </div>
            <div class="k-d-flex district-borough">
                <kendo-floatinglabel text="District" class="functional-grade-level__form-label district-borough-width">
                    <kendo-multiselect [data]="referenceData?.district" size="large" rounded="large"
                        [textField]="'description'" [valueField]="'id'" formControlName="district">
                    </kendo-multiselect>
                </kendo-floatinglabel>
                <kendo-floatinglabel text="Borough" class="functional-grade-level__form-label district-borough-width">
                    <kendo-dropdownlist [data]="referenceData?.borough" size="large" rounded="large"
                        textField="description" valueField="description" formControlName="borough">
                    </kendo-dropdownlist>
                </kendo-floatinglabel>

            </div>
            <div class="divider"></div>
            <!-- /////////////////////////////   School Types//////////////////////////////////// -->
            <div>
                <div class="k-d-inline-flex k-align-items-baseline">
                    <h4 class="k-mr-2">Site Types</h4>
                    <button kendoButton *ngIf="currentAction !== 'select'" class="link-button" fillMode="link"
                        themeColor="base" (click)="toggleSelectAll(true)">( select all
                        )</button>
                    <button kendoButton *ngIf="currentAction === 'select'" class="link-button" fillMode="link"
                        themeColor="base" (click)="toggleSelectAll(false)">( deselect all
                        )</button>
                </div>
                <div class="k-mt-2">
                    <div *ngFor="let item of constants.siteTypesPreschool" class="checkbox-group">
                        <div class="checkbox-item">
                            <label>
                                <input type="checkbox" kendoCheckBox [formControlName]="item.control" />
                                {{ item.text }}
                            </label>
                        </div>
                        <div class="nested-checkbox-group k-mt-2" *ngIf="item.items && showNestedFields">
                            <ul class="k-checkbox-list">
                                <li *ngFor="let subItem of item.items" class="k-checkbox-item">
                                    <label>
                                        <input type="checkbox" kendoCheckBox [formControlName]="subItem.control" />
                                        {{ subItem.text }}
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider"></div>
            <h4 class="!k-m-0"> Recommended Programs</h4>
            <kendo-floatinglabel text="Program" class="k-w-full">
                <kendo-multiselect [data]="programList" [textField]="'description'" [valueField]="'id'"
                    formControlName="programs"></kendo-multiselect>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Ratio" class="k-w-full">
                <kendo-multiselect [data]="referenceData?.seRatio" [textField]="'description'" [valueField]="'id'"
                    formControlName="ratio"></kendo-multiselect>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Language" class="k-w-full" *ngIf="studentDetails?.isPreSchool">
                <kendo-multiselect [data]="referenceData?.language" textField="description" [valuePrimitive]="true"
                    valueField="id" formControlName="language"></kendo-multiselect>
            </kendo-floatinglabel>

        </ng-container>
        <div class="k-d-flex k-justify-content-between k-pt-6">
            <button kendoButton themeColor="secondary" size="large" rounded="large" fillMode="outline"
                (click)="resetFilters()">
                Reset Filters
            </button>
            <button kendoButton themeColor="primary" size="large" rounded="large" fillMode="solid"
                (click)="onShowresults()">
                Show Results
            </button>
        </div>

    </div>
</form>